export default {
  path: '/match',
  name: 'Match',
  redirect: '/match/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      name: 'MatchList',
      component: () => import('@/views/match'),
      meta: { requiresAuth: true }
    },
    {
      path: 'addMatch', // 添加赛事
      name: 'AddMatch',
      component: () => import('@/views/match/addMatch'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      name: 'MatchDetail',
      component: () => import('@/views/match/matchDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'list_tournament',
      name: 'indexTournament',
      component: () => import('@/views/match/indexTournament'),
      meta: { requiresAuth: true }
    },
    {
      path: 'addMatchTournament', // 添加赛事
      name: 'AddMatchTournament',
      component: () => import('@/views/match/addMatchTournament'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detailTournament', // 添加赛事
      name: 'DetailTournament',
      component: () => import('@/views/match/matchTournamentDetail'),
      meta: { requiresAuth: true }
    },
  ]
}
